import { Card, Form, FormInstance, Radio } from 'antd';
import Title from 'antd/lib/typography/Title';

import IpListField, { IpFilterFormItem } from '../IpListField';

/** 管理者画面セキュリティセクションのフォーム値の型 */
export type AdminSecuritySectionFormValues = {
    mfaRequired: boolean;
    ipRestrictionEnabled: boolean;
    ipFilters: IpFilterFormItem[];
};

interface AdminSecuritySectionProps {
    /** セクションのタイトル (例: "全体管理者画面のセキュリティ設定") */
    title: string;
    /** 多要素認証要求フィールド名 */
    mfaRequiredFieldName: string;
    /** IP アドレス制限フィールド名 */
    isIpFiltersEnableName: string;
    /** IP フィルターリストフィールド名 */
    ipFiltersFieldName: string;
    /** 親フォームのインスタンス */
    form: FormInstance;
    /** 多要素認証要求フィールドの無効化状態 (セクション有効フラグ + ローディング) */
    disabled?: boolean;
    /** IP フィルター項目の無効化状態 (ローディングのみ) */
    ipFilterDisabled?: boolean;
    /** ラベルなしのオフセットレイアウト */
    layoutWithoutLabel: object;
    /** 追加ボタンのレイアウト */
    layoutWithAddButton: object;
    tooltip: string;
}

/**
 * 管理者画面のセキュリティ設定セクション (再利用可能コンポーネント)
 * 全体管理者・学校管理者など各管理者画面の MFA 要求と IP 制限を管理する
 */
const AdminSecuritySection: React.FC<AdminSecuritySectionProps> = ({
    title,
    mfaRequiredFieldName,
    isIpFiltersEnableName,
    ipFiltersFieldName,
    form,
    disabled = false,
    ipFilterDisabled = false,
    layoutWithoutLabel,
    layoutWithAddButton,
    tooltip,
}) => {
    return (
        <Card title={<Title level={4}>{title}</Title>} type='inner' style={{ marginTop: '20px' }}>
            {/* 多要素認証要求 */}
            <Form.Item
                label='多要素認証を要求する'
                name={mfaRequiredFieldName}
                tooltip={tooltip}
            >
                <Radio.Group disabled={disabled}>
                    <Radio value={false}>要求しない</Radio>
                    <Radio value={true}>要求する</Radio>
                </Radio.Group>
            </Form.Item>

            {/* IP アドレス制限 (「制限しない」を選択してもリストの値は保持される) */}
            <Form.Item
                label='IPアドレスを制限する'
                name={isIpFiltersEnableName}
            >
                <Radio.Group disabled={ipFilterDisabled}>
                    <Radio value={false}>制限しない</Radio>
                    <Radio value={true}>制限する</Radio>
                </Radio.Group>
            </Form.Item>

            {/* IP アドレスリスト (制限する/制限しないに関わらず常時表示する) */}
            <IpListField
                form={form}
                layoutWithAddButton={layoutWithAddButton}
                layoutWithoutLabel={layoutWithoutLabel}
                listName={ipFiltersFieldName}
            />
        </Card>
    );
};

export default AdminSecuritySection;
